/**
 * Swagger Lucor
 * Swagger Lucor
 *
 * OpenAPI spec version: 1.2.18
 * Contact: roger.cazangi@hotmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Ciencia } from '../model/ciencia';
import { Fator } from '../model/fator';
import { NewPerfil } from '../model/newPerfil';
import { Nivel } from '../model/nivel';
import { UpdFator } from '../model/updFator';
import { UpdFiltroFator } from '../model/updFiltroFator';
import { UpdNivel } from '../model/updNivel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';

import { environment } from '../../environments/environment';


@Injectable()
export class CienciaApiService {

    protected basePath = environment.apiBasePath;
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Atualizar Dados de um Fator
     * 
     * @param body 
     * @param cienciaId 
     * @param fatorId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CienciaCienciaIdFatorFatorIdPut(body: UpdFator, cienciaId: number, fatorId: number, observe?: 'body', reportProgress?: boolean): Observable<Fator>;
    public v1CienciaCienciaIdFatorFatorIdPut(body: UpdFator, cienciaId: number, fatorId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Fator>>;
    public v1CienciaCienciaIdFatorFatorIdPut(body: UpdFator, cienciaId: number, fatorId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Fator>>;
    public v1CienciaCienciaIdFatorFatorIdPut(body: UpdFator, cienciaId: number, fatorId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling v1CienciaCienciaIdFatorFatorIdPut.');
        }

        if (cienciaId === null || cienciaId === undefined) {
            throw new Error('Required parameter cienciaId was null or undefined when calling v1CienciaCienciaIdFatorFatorIdPut.');
        }

        if (fatorId === null || fatorId === undefined) {
            throw new Error('Required parameter fatorId was null or undefined when calling v1CienciaCienciaIdFatorFatorIdPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Fator>('put',`${this.basePath}/v1/ciencia/${encodeURIComponent(String(cienciaId))}/fator/${encodeURIComponent(String(fatorId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Definir Palavras-Chave Associadas aos Fatores da Ciência
     * 
     * @param body 
     * @param cienciaId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CienciaCienciaIdFatorPut(body: UpdFiltroFator, cienciaId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<Fator>>;
    public v1CienciaCienciaIdFatorPut(body: UpdFiltroFator, cienciaId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Fator>>>;
    public v1CienciaCienciaIdFatorPut(body: UpdFiltroFator, cienciaId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Fator>>>;
    public v1CienciaCienciaIdFatorPut(body: UpdFiltroFator, cienciaId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling v1CienciaCienciaIdFatorPut.');
        }

        if (cienciaId === null || cienciaId === undefined) {
            throw new Error('Required parameter cienciaId was null or undefined when calling v1CienciaCienciaIdFatorPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<Fator>>('put',`${this.basePath}/v1/ciencia/${encodeURIComponent(String(cienciaId))}/fator`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obter Ciência pelo Id
     * 
     * @param cienciaId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CienciaCienciaIdGet(cienciaId: number, observe?: 'body', reportProgress?: boolean): Observable<Ciencia>;
    public v1CienciaCienciaIdGet(cienciaId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Ciencia>>;
    public v1CienciaCienciaIdGet(cienciaId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Ciencia>>;
    public v1CienciaCienciaIdGet(cienciaId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cienciaId === null || cienciaId === undefined) {
            throw new Error('Required parameter cienciaId was null or undefined when calling v1CienciaCienciaIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Ciencia>('get',`${this.basePath}/v1/ciencia/${encodeURIComponent(String(cienciaId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar Níveis Configurados para a Ciência
     * 
     * @param cienciaId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CienciaCienciaIdNiveisGet(cienciaId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<Nivel>>;
    public v1CienciaCienciaIdNiveisGet(cienciaId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Nivel>>>;
    public v1CienciaCienciaIdNiveisGet(cienciaId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Nivel>>>;
    public v1CienciaCienciaIdNiveisGet(cienciaId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cienciaId === null || cienciaId === undefined) {
            throw new Error('Required parameter cienciaId was null or undefined when calling v1CienciaCienciaIdNiveisGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Nivel>>('get',`${this.basePath}/v1/ciencia/${encodeURIComponent(String(cienciaId))}/niveis`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar Perfis Configurados para a Ciência Especificamente para um Cliente
     * 
     * @param cienciaId 
     * @param clienteId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CienciaCienciaIdPerfisClienteClienteIdGet(cienciaId: number, clienteId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<NewPerfil>>;
    public v1CienciaCienciaIdPerfisClienteClienteIdGet(cienciaId: number, clienteId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<NewPerfil>>>;
    public v1CienciaCienciaIdPerfisClienteClienteIdGet(cienciaId: number, clienteId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<NewPerfil>>>;
    public v1CienciaCienciaIdPerfisClienteClienteIdGet(cienciaId: number, clienteId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cienciaId === null || cienciaId === undefined) {
            throw new Error('Required parameter cienciaId was null or undefined when calling v1CienciaCienciaIdPerfisClienteClienteIdGet.');
        }

        if (clienteId === null || clienteId === undefined) {
            throw new Error('Required parameter clienteId was null or undefined when calling v1CienciaCienciaIdPerfisClienteClienteIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<NewPerfil>>('get',`${this.basePath}/v1/ciencia/${encodeURIComponent(String(cienciaId))}/perfis/cliente/${encodeURIComponent(String(clienteId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Atualizar Configuração de Perfis para a Ciência Especificamente para um Cliente
     * 
     * @param body 
     * @param cienciaId 
     * @param clienteId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CienciaCienciaIdPerfisClienteClienteIdPut(body: Array<NewPerfil>, cienciaId: number, clienteId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<NewPerfil>>;
    public v1CienciaCienciaIdPerfisClienteClienteIdPut(body: Array<NewPerfil>, cienciaId: number, clienteId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<NewPerfil>>>;
    public v1CienciaCienciaIdPerfisClienteClienteIdPut(body: Array<NewPerfil>, cienciaId: number, clienteId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<NewPerfil>>>;
    public v1CienciaCienciaIdPerfisClienteClienteIdPut(body: Array<NewPerfil>, cienciaId: number, clienteId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling v1CienciaCienciaIdPerfisClienteClienteIdPut.');
        }

        if (cienciaId === null || cienciaId === undefined) {
            throw new Error('Required parameter cienciaId was null or undefined when calling v1CienciaCienciaIdPerfisClienteClienteIdPut.');
        }

        if (clienteId === null || clienteId === undefined) {
            throw new Error('Required parameter clienteId was null or undefined when calling v1CienciaCienciaIdPerfisClienteClienteIdPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<NewPerfil>>('put',`${this.basePath}/v1/ciencia/${encodeURIComponent(String(cienciaId))}/perfis/cliente/${encodeURIComponent(String(clienteId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar Perfis Configurados para a Ciência
     * 
     * @param cienciaId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CienciaCienciaIdPerfisGet(cienciaId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<NewPerfil>>;
    public v1CienciaCienciaIdPerfisGet(cienciaId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<NewPerfil>>>;
    public v1CienciaCienciaIdPerfisGet(cienciaId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<NewPerfil>>>;
    public v1CienciaCienciaIdPerfisGet(cienciaId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cienciaId === null || cienciaId === undefined) {
            throw new Error('Required parameter cienciaId was null or undefined when calling v1CienciaCienciaIdPerfisGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<NewPerfil>>('get',`${this.basePath}/v1/ciencia/${encodeURIComponent(String(cienciaId))}/perfis`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Atualizar Configuração de Perfis para a Ciência
     * 
     * @param body 
     * @param cienciaId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CienciaCienciaIdPerfisPut(body: Array<NewPerfil>, cienciaId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<NewPerfil>>;
    public v1CienciaCienciaIdPerfisPut(body: Array<NewPerfil>, cienciaId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<NewPerfil>>>;
    public v1CienciaCienciaIdPerfisPut(body: Array<NewPerfil>, cienciaId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<NewPerfil>>>;
    public v1CienciaCienciaIdPerfisPut(body: Array<NewPerfil>, cienciaId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling v1CienciaCienciaIdPerfisPut.');
        }

        if (cienciaId === null || cienciaId === undefined) {
            throw new Error('Required parameter cienciaId was null or undefined when calling v1CienciaCienciaIdPerfisPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<NewPerfil>>('put',`${this.basePath}/v1/ciencia/${encodeURIComponent(String(cienciaId))}/perfis`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar Ciências
     * 
     * @param withoutChildren 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CienciaGet(withoutChildren?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<Ciencia>>;
    public v1CienciaGet(withoutChildren?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Ciencia>>>;
    public v1CienciaGet(withoutChildren?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Ciencia>>>;
    public v1CienciaGet(withoutChildren?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (withoutChildren !== undefined && withoutChildren !== null) {
            queryParameters = queryParameters.set('withoutChildren', <any>withoutChildren);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Ciencia>>('get',`${this.basePath}/v1/ciencia`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Atualizar Configuração de Nivel para a Ciência
     * 
     * @param body 
     * @param nivelId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1CienciaNiveisNivelIdPut(body: UpdNivel, nivelId: number, observe?: 'body', reportProgress?: boolean): Observable<Nivel>;
    public v1CienciaNiveisNivelIdPut(body: UpdNivel, nivelId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Nivel>>;
    public v1CienciaNiveisNivelIdPut(body: UpdNivel, nivelId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Nivel>>;
    public v1CienciaNiveisNivelIdPut(body: UpdNivel, nivelId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling v1CienciaNiveisNivelIdPut.');
        }

        if (nivelId === null || nivelId === undefined) {
            throw new Error('Required parameter nivelId was null or undefined when calling v1CienciaNiveisNivelIdPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Nivel>('put',`${this.basePath}/v1/ciencia/niveis/${encodeURIComponent(String(nivelId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
